<template lang="pug">
  .site-message-banner(v-if="hasMessage")
    .row.color-white.text-center.xs-f-small.lg-f-medium.max-at-tweak(v-bind:style="{'background-color': backgroundColor(message)}")
      .xs-12(v-html="message.message")

</template>

<script>
  import vueSiteMessageSvc from '../../services/vueSiteMessageSvc';

  export default {
    name: "SiteMessageBanner",

    props: {
      topics: {
        type: String
      }
    },

    computed: {
      hasMessage() {
        return !!(this.message);
      },
    },

    asyncComputed: {
      message: {
        lazy: true,
        get() {
          if (this.topics) {
            // There should only ever be one global message
            return vueSiteMessageSvc.getByTopics({ topics: this.topics }).then(res => res.data[0]);
          }
        }
      }
    },
    methods: {
      backgroundColor(message) {
        if (message.background_color) {
          return message.background_color;
        }
        return "#000";
      }
    }
  };
</script>

<style lang="stylus">
  .site-message-banner
    .row
      max-width 100%
      padding 1.2em 5%

</style>
